:host {
  height: auto;
  width: auto;
  --margin-bottom-wrapper: calc(2 * var(--spacer));
  --form-field-label-width: 250px;
  --label-font-family: var(--font-family-secondary);
  --label-font-size: var(--body-size-large);

  &.hidden {
    display: none;
  }
}

:host(.label-mw-250) {
  .form-field-label {
    min-width: 250px;
  }
}

#form-field-toggle {
  --margin-bottom-wrapper: 0;
}

.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: start;
  margin-bottom: var(--margin-bottom-wrapper);

  .form-field-label {
    width: var(--form-field-label-width);
    font-size: var(--label-font-size);
    font-family: var(--label-font-family);
    padding-top: var(--spacer);
    color: var(--main-titles-inputs-600);
    display: inline-table;

    &.toggle-label {
      display: flex;
      flex-direction: row;

      justify-content: start;
      align-items: center;
      padding-top: 0;
      height: calc(4 * var(--spacer));

      gz-toggle {
        min-width: 0;
        min-height: 0;
        width: auto;
        height: auto;
        --margin-vertical: 5px;
      }
    }

    &.required:after {
      content: '*:';
    }

    &:after {
      content: ':';
    }
  }

  .input-wrapper {
    --form-field-input-width: 240px;
    flex-grow: 1;
  }
}

:host([disabled]) {
  pointer-events: none;
  cursor: default;
  .wrapper {
    .form-field-label {
      opacity: 0.3;
    }
  }
}

:host(.toggle-field-indented) {
  .wrapper {
    .form-field-label {
      padding-left: calc(5 * var(--spacer));
    }
  }
}

:host([stacked]) {
  .wrapper {
    flex-direction: column;

    .form-field-label {
      margin-bottom: var(--spacer);
    }

    .input-wrapper {
      width: 100%;
    }
  }
}

:host([disableVerticalMargin]) {
  .wrapper {
    margin-bottom: 0;
  }
}
